import React from 'react';
import Container from 'container';
import { Link } from 'gatsby';
import s from './breadcrumbs.module.scss';

export default function Breadcrumbs({ breadcrumbs, ...props }) {
return (
  <Container className={s.root}>
    <ul className={s.list}>
      {breadcrumbs.map(({ name, slug }, i, arr) => (
        <React.Fragment key={`${name}-${slug}`}>
          <li className={s.item}>
            { slug ? (
              <Link to={`/${slug}`} dangerouslySetInnerHTML={{ __html: name }} />
          ) : <>{ name }</>}
          </li>
          {i !== arr.length - 1 && <span className={s.separator}> / </span>}
        </React.Fragment>
    ))}
    </ul>
  </Container>
);
}
